import * as React from "react";

function UnorderedListOutline(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "UnorderedListOutline-UnorderedListOutline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UnorderedListOutline-\u7F16\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "UnorderedListOutline-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,32 C10.9852814,32 13,34.0147186 13,36.5 C13,38.9852814 10.9852814,41 8.5,41 C6.01471863,41 4,38.9852814 4,36.5 C4,34.0147186 6.01471863,32 8.5,32 Z M8.5,35 C7.67157288,35 7,35.6715729 7,36.5 C7,37.3284271 7.67157288,38 8.5,38 C9.32842712,38 10,37.3284271 10,36.5 C10,35.6715729 9.32842712,35 8.5,35 Z M43.6,35 C43.8209139,35 44,35.1790861 44,35.4 L44,37.6 C44,37.8209139 43.8209139,38 43.6,38 L16.4,38 C16.1790861,38 16,37.8209139 16,37.6 L16,35.4 C16,35.1790861 16.1790861,35 16.4,35 L43.6,35 Z M8.5,19 C10.9852814,19 13,21.0147186 13,23.5 C13,25.9852814 10.9852814,28 8.5,28 C6.01471863,28 4,25.9852814 4,23.5 C4,21.0147186 6.01471863,19 8.5,19 Z M8.5,22 C7.67157288,22 7,22.6715729 7,23.5 C7,24.3284271 7.67157288,25 8.5,25 C9.32842712,25 10,24.3284271 10,23.5 C10,22.6715729 9.32842712,22 8.5,22 Z M43.6,22 C43.8209139,22 44,22.1790861 44,22.4 L44,24.6 C44,24.8209139 43.8209139,25 43.6,25 L16.4,25 C16.1790861,25 16,24.8209139 16,24.6 L16,22.4 C16,22.1790861 16.1790861,22 16.4,22 L43.6,22 Z M8.5,6 C10.9852814,6 13,8.01471863 13,10.5 C13,12.9852814 10.9852814,15 8.5,15 C6.01471863,15 4,12.9852814 4,10.5 C4,8.01471863 6.01471863,6 8.5,6 Z M8.5,9 C7.67157288,9 7,9.67157288 7,10.5 C7,11.3284271 7.67157288,12 8.5,12 C9.32842712,12 10,11.3284271 10,10.5 C10,9.67157288 9.32842712,9 8.5,9 Z M43.6,9 C43.8209139,9 44,9.1790861 44,9.4 L44,11.6 C44,11.8209139 43.8209139,12 43.6,12 L16.4,12 C16.1790861,12 16,11.8209139 16,11.6 L16,9.4 C16,9.1790861 16.1790861,9 16.4,9 L43.6,9 Z",
    id: "UnorderedListOutline-\u5F62\u72B6\u7ED3\u5408",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default UnorderedListOutline;